import { Loader2, Mic, MicOff, Stethoscope, User } from "lucide-react";

/**
 * Two big mic buttons: therapist (top) and patient (bottom).
 */
export default function ConversationMicCards({
  therapistLang,
  patientLang,
  recording,    // 'therapist' | 'patient' | null
  working,      // 'therapist' | 'patient' | null
  onTherapistClick,
  onPatientClick,
}) {
  const isBusy = !!working;

  return (
    <div className="grid grid-cols-2 gap-4">
      <button
        onClick={onTherapistClick}
        disabled={isBusy || (recording && recording !== "therapist")}
        className={`relative rounded-2xl border-2 p-6 md:p-8 text-left transition-all duration-200 ${
          recording === "therapist"
            ? "border-red-500 bg-red-50"
            : working === "therapist"
            ? "border-zinc-300 bg-zinc-50"
            : "border-zinc-900 bg-zinc-900 text-white hover:bg-zinc-800"
        } disabled:opacity-50 disabled:cursor-not-allowed`}
        data-testid="conv-mic-therapist"
      >
        <div className="flex items-center justify-between mb-3">
          <Stethoscope className={`w-5 h-5 ${recording === "therapist" || working === "therapist" ? "text-zinc-700" : "text-white"}`} />
          <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
            recording === "therapist" ? "bg-red-500 text-white animate-pulse"
            : working === "therapist" ? "bg-zinc-200 text-zinc-700"
            : "bg-white text-zinc-900"
          }`}>
            {working === "therapist"
              ? <Loader2 className="w-5 h-5 animate-spin" />
              : recording === "therapist"
              ? <MicOff className="w-5 h-5" />
              : <Mic className="w-5 h-5" />}
          </div>
        </div>
        <p className={`text-xs uppercase tracking-[0.2em] mb-1 ${recording === "therapist" || working === "therapist" ? "text-zinc-500" : "text-zinc-400"}`}>
          You · {therapistLang}
        </p>
        <p className="font-heading text-xl md:text-2xl tracking-tight leading-tight">
          {recording === "therapist"
            ? "Listening… tap to stop"
            : working === "therapist"
            ? "Translating…"
            : "Tap to speak as therapist"}
        </p>
      </button>

      <button
        onClick={onPatientClick}
        disabled={isBusy || (recording && recording !== "patient")}
        className={`relative rounded-2xl border-2 p-6 md:p-8 text-left transition-all duration-200 ${
          recording === "patient"
            ? "border-red-500 bg-red-50"
            : working === "patient"
            ? "border-zinc-200 bg-zinc-50"
            : "border-zinc-200 bg-white hover:bg-zinc-50"
        } disabled:opacity-50 disabled:cursor-not-allowed`}
        data-testid="conv-mic-patient"
      >
        <div className="flex items-center justify-between mb-3">
          <User className="w-5 h-5 text-zinc-500" />
          <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
            recording === "patient" ? "bg-red-500 text-white animate-pulse"
            : working === "patient" ? "bg-zinc-200 text-zinc-700"
            : "bg-zinc-900 text-white"
          }`}>
            {working === "patient"
              ? <Loader2 className="w-5 h-5 animate-spin" />
              : recording === "patient"
              ? <MicOff className="w-5 h-5" />
              : <Mic className="w-5 h-5" />}
          </div>
        </div>
        <p className="text-xs uppercase tracking-[0.2em] mb-1 text-zinc-500">Patient · {patientLang}</p>
        <p className="font-heading text-xl md:text-2xl tracking-tight leading-tight text-zinc-900">
          {recording === "patient"
            ? "Listening… tap to stop"
            : working === "patient"
            ? "Translating…"
            : "Hand the device — tap to speak"}
        </p>
      </button>
    </div>
  );
}
